import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { Defaults } from 'src/app/Utilities/defaults';

@Component({
  selector: 'app-demographics-header',
  templateUrl: './demographics-header.component.html',
  styleUrls: ['./demographics-header.component.css']
})
export class DemographicsHeaderComponent implements OnInit {
  @Input() activetab = 1;
  patId: number = CommonComponents.patientId;
  patName: string = CommonComponents.patientName;

  constructor(private router: Router) { }

  ngOnInit() {
  }
  onLinkClick(event: MatTabChangeEvent) {
    event.tab.isActive = true;
    sessionStorage.setItem("demoheaderVisibility", "true");
    sessionStorage.setItem("visitNoteAlertsheaderVisibility", "true");
    if (event.tab.textLabel == 'Forms') {

      var DocLibraryPatDemographicsID = Defaults.DocLibraryPatDemographicsID;
      //this.router.navigate(['Demographics/'+ event.tab.textLabel,DocLibraryPatDemographicsID]);
      this.router.navigateByUrl('/Demographics/ConsentForms/' + DocLibraryPatDemographicsID);
    }
    else {
      this.router.navigateByUrl('/Demographics/' + event.tab.textLabel);
    }

  }
}
